<template>
  <div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllContratSelected().length > 0"
            ></selecteur-action>
          </div>
          <div class="column is-narrow">
            <form @submit.prevent="recherche()">
              <b-input :placeholder="$t('general.placeHolder.search')"
                       type="search"
                       v-model="critereRecherche.auto"
                       icon="magnify">
              </b-input>
            </form>
          </div>
          <div class="column is-narrow">
            <button class="button" @click="showFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
               <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                       :class="getFilteredNumber > 0 ? '' : 'is-invisible'">
                  ({{ getFilteredNumber }})
                </label>
              </span>
            </button>
           <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permContrat.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      v-if="startArrayRendering">
      <template slot='afterTable'>
        <table-items-in-view :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="contrats">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <qd-checkbox v-if="props.row.selected !== undefined"
                    v-model="props.row.selected"
                    :value="props.row">
        </qd-checkbox>
      </div>
      <div slot="code" slot-scope="props">
        <router-link :to="{ name: 'c.baux.contrat', params: { id: props.row.id } }"
                     v-if="props.row.id"
                     class="lien" :class="{'text-access-no-permission':
                     !checkPermissions(permContrat.lecture)}">
          {{ props.row.code }}
        </router-link>
      </div>
      <div slot="type" slot-scope="props">
        {{ $t(getTypeLibelleContrat(props.row.type)) }}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtatContrat(props.row.etat)) }}
      </div>
      <div slot="dateFinSignature" slot-scope="props">
        {{ props.row.dateFinSignature | formatDate }}
      </div>
      <div slot="dateFinEcheance" slot-scope="props">
        {{ props.row.dateFinEcheance | formatDate }}
      </div>
      <div slot="datePreavis" slot-scope="props">
        {{ props.row.datePreavis | formatDate }}
      </div>
      <div slot="bailleur" slot-scope="props">
        {{ getLibelleBailleur(props.row.intervenants) }}
      </div>
      <div slot="loyerAnnuelHt" slot-scope="props" class="right"
           :class="{ 'has-text-weight-bold' : props.row.selected === undefined}">
        {{ props.row.loyerAnnuelHt | formatDevise }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId)}}
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="filtreVisible">
        <filtre-liste-contrat-reconductible ref="filtreListeContratReconductible"
                                     @toggleFiltre="showFiltre"
                                     :critereRecherche="critereRecherche"
                                     @recherche="makeRechercheFilter"/>
      </div>
    </transition>
    <b-modal v-model="popUpReconductionContrat" has-modal-card class="modal">
      <reconduction-contrat :contratsAReconduire="contratsAReconduire"
                            @closeAndRefresh="closeAndRefresh"/>
    </b-modal>
    <b-modal v-model="popupEtatRenouvellement" has-modal-card class="modal">
      <popUpRenouvellement :contrats="getAllContratSelected()"
                :etatRenouvellement="constantes.ETAT_NONRENOUVELEE"
                @reload="recherche"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import {
  ACTION_RECONDUIRE, LISTE_ETAT_CONTRAT, LISTE_TYPE_CONTRAT, EXPORT_EXCEL_TYPE_DONNEES_CONTRATS,
} from '@/configuration/baux/contrat/contratConf';
import inProgress from '@/services/general/inProgress';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import filtreListeContratReconductible from '@/components/baux/contrat/filtre/filtreListeContratReconductible';
import { SET_CRITERE_RECHERCHE_RECONDUCTIBLE } from '@/store/modules/baux/contrat-mutation-type';
import formatIsoDate from '@/services/general/formatIsoDate';
import reconductionContrat from '@/components/baux/contrat/p_reconductionContrat';
import transform from '@/services/baux/contrat/contratServerTableDataTransformer';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LISTE_CONTRAT_RECONDUCTIBLE } from '@/configuration/general/referenceTableConf';
import { ACTION_MASS_ETAT_NON_RENOUVELLE } from '@/configuration/general/actionsConf';
import popUpRenouvellement from '@/components/baux/contrat/componentDetail/popUpRenouvellement';
import { ETAT_NONRENOUVELEE } from '@/configuration/devisConf';

const Permissions = createNamespacedHelpers('permissions');
const Contrat = createNamespacedHelpers('contrat');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      permContrat: CONTRAT,
      unsubscribeValue: null,
      filtreVisible: false,
      popUpReconductionContrat: false,
      contratsAReconduire: [],
      actions: [
        { action: ACTION_RECONDUIRE, translation: 'listeContratReconductible.actions.reconduire' },
        {
          action: ACTION_MASS_ETAT_NON_RENOUVELLE,
          translation: 'listeContrat.actions.editEtatNonRenouvelle',
        },
      ],
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_LISTE_CONTRAT_RECONDUCTIBLE,
      resultPerPage: RESULTS_PER_PAGE,
      constantes: {
        ETAT_NONRENOUVELEE,
      },
      popupEtatRenouvellement: false,
    };
  },
  components: {
    selecteurAction,
    TableItemsInView,
    filtreListeContratReconductible,
    reconductionContrat,
    tableFooterTotaux,
    exportExcelButton,
    parametrageTable,
    popUpRenouvellement,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Contrat.mapGetters({
      contrats: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'critereRechercheContratReconductible',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    getFilteredNumber() {
      let number = 0;
      if (this.critereRecherche.tacite) number += 1;
      if (this.critereRecherche.naturesId.length > 0) number += 1;
      if (this.critereRecherche.contratType.length > 0) number += 1;
      if (this.critereRecherche.termePaiement.length > 0) number += 1;
      if (this.critereRecherche.etat.length > 0) number += 1;
      if (this.critereRecherche.dateFinEcheance) number += 1;
      if (this.critereRecherche.datePreavis) number += 1;
      if (this.critereRecherche.agencesId.length > 0) number += 1;
      return number;
    },
    allContratSelected() {
      return this.getAllContratSelected().length === this.contrats.length
        && this.contrats.length > 0;
    },
    iconSelectTotal() {
      if (this.allContratSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeContratReconductible.tab.code'),
          type: this.$i18n.t('listeContratReconductible.tab.type'),
          dateFinSignature: this.$i18n.t('listeContratReconductible.tab.finContrat'),
          bailleur: this.$i18n.t('listeContratReconductible.tab.bailleur'),
          loyerAnnuelHt: this.$i18n.t('listeContratReconductible.tab.loyer'),
          agence: this.$i18n.t('listeContratReconductible.tab.agence'),
          'nature.libelle': this.$i18n.t('listeContratReconductible.tab.natureBail'),
          dateFinEcheance: this.$i18n.t('listeContratReconductible.tab.dateFinEcheance'),
          datePreavis: this.$i18n.t('listeContratReconductible.tab.datePreavis'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.critereRecherche);
          if (data.query.datePreavis && (moment(data.query.datePreavis.dateDebut, 'YYYY-DD-MM', true).isValid() || moment(data.query.datePreavis.dateFin, 'YYYY-DD-MM', true).isValid())) {
            data.query.datePreavis.dateDebut = formatIsoDate(data.query.datePreavis.dateDebut);
            data.query.datePreavis.dateFin = formatIsoDate(data.query.datePreavis.dateFin);
          }
          if (data.query.dateFinEcheance && (moment(data.query.dateFinEcheance.dateDebut, 'YYYY-DD-MM', true).isValid() || moment(data.query.dateFinEcheance.dateFin, 'YYYY-DD-MM', true).isValid())) {
            data.query.dateFinEcheance.dateDebut = formatIsoDate(
              data.query.dateFinEcheance.dateDebut,
            );
            data.query.dateFinEcheance.dateFin = formatIsoDate(data.query.dateFinEcheance.dateFin);
          }
          if (this.critereRecherche.agencesId.length === 0) {
            data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          data.query.societeId = this.societeActiveId;
          data.query.reconductible = true;
          return this.actionLoadContrat(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.contrats,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: ['code', 'nature.libelle', 'type', 'dateFinSignature', 'dateFinEcheance', 'datePreavis', 'loyerAnnuelHt'],
      };
    },
    targetTotal() {
      return ['loyerAnnuelHt'];
    },
    columns() {
      const columns = ['selected', 'code', 'nature.libelle', 'type', 'bailleur', 'dateFinSignature', 'dateFinEcheance', 'datePreavis', 'loyerAnnuelHt'];
      if (this.agencesSelectionnees.length > 1) columns.splice(columns.length - 1, 0, 'agence');
      return columns;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_TYPE_DONNEES_CONTRATS,
        typeExport: '',
        filtres: transform(this.lastPayload),
      };
    },
  },
  methods: {
    ...Contrat.mapActions({
      actionLoadContrat: 'loadContrat',
    }),
    ...Contrat.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE_RECONDUCTIBLE,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    closeAndRefresh() {
      this.popUpReconductionContrat = false;
      this.recherche();
    },
    reconductionContrat(contratsAReconduire) {
      this.contratsAReconduire = contratsAReconduire;
      this.popUpReconductionContrat = true;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_RECONDUIRE:
          this.reconductionContrat(this.getAllContratSelected());
          break;
        case ACTION_MASS_ETAT_NON_RENOUVELLE:
          if (this.checkPermissions(this.permContrat.maj)) {
            this.popupEtatRenouvellement = true;
          } else this.showPopUp();
          break;
        default:
          break;
      }
    },
    async showFiltre() {
      this.filtreVisible = !this.filtreVisible;
      if (this.filtreVisible) await this.$refs.filtreListeContratReconductible.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter(critereUpdate) {
      this.setCritereRecherche(critereUpdate);
      if (this.filtreVisible) this.showFiltre();
      this.recherche();
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeContratReconductible.initializeFiltre();
      this.$refs.filtreListeContratReconductible.viderCritere();
      this.$refs.filtreListeContratReconductible.appliquerCritere();
      this.filtreVisible = false;
    },
    finLoading() {
      this.loadingComponent.close();
    },
    selectAll() {
      const select = !this.allContratSelected;
      this.contrats.forEach((el) => {
        if (el.selected !== undefined) el.selected = select;
      });
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    getLibelleBailleur(bailleurs) {
      let bailleurLibelle = '';
      if (!bailleurs) return '';
      bailleurs.forEach((bailleur) => {
        if (bailleurLibelle) bailleurLibelle += ', ';
        bailleurLibelle += bailleur.tiers.nomCommercial;
      });
      return bailleurLibelle;
    },
    getTypeLibelleContrat(type) {
      const typeFind = LISTE_TYPE_CONTRAT.find((listeType) => {
        return listeType.code === type;
      });
      return typeFind ? typeFind.libelle : '';
    },
    getEtatContrat(etat) {
      const etatFind = LISTE_ETAT_CONTRAT.find((listeEtat) => {
        return listeEtat.code === etat;
      });
      return etatFind ? etatFind.libelle : '';
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    updateAgenceAndRecherche() {
      this.critereRecherche.agencesId = [];
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    getAllContratSelected() {
      return this.contrats.filter((el) => {
        return el.selected;
      });
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.updateAgenceAndRecherche, this.goFirstPage);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
